export const GOOGLE_MAP_API_KEY = 'AIzaSyDLYkWRtenvhgoApe7EBdLH3rBI1X2ssWk';

